import axios, { AxiosError, AxiosResponse, HttpStatusCode } from "axios";
import Keys from "@utils/keys";
import { IGetEligibilityRequest, IBiometryRequest } from "@config/types";
const ROOT_URL = Keys.SERVICOS.API.ROOT_URL;

export type NullableType<D> = D | null;
export interface IResponse<D, E = any> {
  status: HttpStatusCode;
  data: NullableType<D>;
  error: NullableType<E>;
}

class Response<D, E> implements IResponse<D, E> {
  constructor(
    status: HttpStatusCode,
    response: AxiosResponse<D> | AxiosError<E>
  ) {
    this.status = status;
    this.data = null;
    this.error = null;
    if (this.isError(response)) {
      if (response.response) this.error = response.response.data;
    } else {
      this.data = response.data;
    }
  }
  private isError = (data: any) => {
    return axios.isAxiosError(data);
  };
  status: HttpStatusCode;
  data: NullableType<D>;
  error: NullableType<E>;
}

export const APIs = {
  PRESTADOR: {
    BUSCAR: `${ROOT_URL}/Prestador`,
  },
  BENEFICIARIO: {
    VERIFICA_ELEGIBILIDADE: `${ROOT_URL}/Beneficiarios/elegibilidade/verificar`,
    SALVAR_RESULTADO_BIOMETRIA: `${ROOT_URL}/Beneficiarios/biometria/salvar`,
  },
  PROFISSIONAL: {
    EXECUTANTE: {
      LISTAR: `${ROOT_URL}/ProfissionalExecutante/filtro/listar`,
      SALVAR: `${ROOT_URL}/ProfissionalExecutante/salvar`,
      DELETAR: `${ROOT_URL}/ProfissionalExecutante/excluir`,
      EDITAR: `${ROOT_URL}/ProfissionalExecutante/editar`,
    },
    SOLICITANTE: {
      LISTAR_TODOS: `${ROOT_URL}/Profissional/listar`,
      LISTAR_FILTRO: `${ROOT_URL}/Profissional/filtrar`,
      SALVAR: `${ROOT_URL}/Profissional/inserir`,
    },
    OCUPACOES: {
      LISTAR_TODAS: `${ROOT_URL}/Ocupacao/listar`,
    },
    ESTADOS: {
      LISTAR: `${ROOT_URL}/Estados/listar`,
    },
    CONSELHOMEDICINA: {
      LISTAR: `${ROOT_URL}/Conselhos/listar`,
    },
    TIPOCONSULTA: {
      LISTAR: `${ROOT_URL}/TipoConsulta/listar`,
    },
    INDICACAOACIDENTE: {
      LISTAR: `${ROOT_URL}/IndicacaoAcidente/listar`,
    },
  },
  SOLICITACAOPROCEDIMENTO: {
    LISTAR_PROCEDIMENTOS_DISPONIVEIS_TODO: `${ROOT_URL}/Procedimentos/listar`,
    LISTAR_PROCEDIMENTOS_DISPONIVEIS_FILTRAR: `${ROOT_URL}/Procedimentos/filtrar`,
    AUTORIZAR: `${ROOT_URL}/Beneficiarios/autorizar`,
  },
  GUIA: {
    BUSCAR: `${ROOT_URL}/Guia/exportar`,
    BUSCAR_CONSULTA: `${ROOT_URL}/Guia/consulta/exportar`,
    LISTAR_TODAS: `${ROOT_URL}/Guia/listar`,
    LISTAR_FILTRO: `${ROOT_URL}/Guia/filtro/listar`,
  },
  COBRANCA: {
    SALVAR: `${ROOT_URL}/Cobrancas/salvar`,
    DELETAR: `${ROOT_URL}/Cobrancas/excluir`,
    LISTAR_TODAS: `${ROOT_URL}/Cobrancas/listar`,
    LISTAR_FILTRO: `${ROOT_URL}/Cobrancas/filtro/listar`,
  },
  LOTEGUIA: {
    ENVIAR_LOTE: `${ROOT_URL}/Lotes/enviar`,
  },
};

const postRequest = <D>(url: string) => {
  return async (body: D) => {
    try {
      const response = await axios.post(url, body);
      return new Response(response.status, response);
    } catch (err: AxiosError | any) {
      if (axios.isAxiosError(err)) {
        if (err.response)
          return new Response(err.response?.status, err.response);
      } else {
        return null;
      }
    }
  };
};

export const getEligibility = async (body: IGetEligibilityRequest) => {
  const request = postRequest(APIs.BENEFICIARIO.VERIFICA_ELEGIBILIDADE);
  return await request(body);
};

export const saveBiometryResult = async (body: IBiometryRequest) => {
  const request = postRequest(APIs.BENEFICIARIO.SALVAR_RESULTADO_BIOMETRIA);
  return await request(body);
};
